export default __webpack_public_path__ + "static/media/setion08_bg_m.8730b2bf.png";